import ComboboxObject from "@/interfaces/Base/Combobox/ComboboxObject";
import BaseEnumerationMember from "./BaseEnumerationMember";

export abstract class BaseEnumeration<Type> {
  abstract GetContents(): BaseEnumerationMember<Type>[];

  public GetComboboxObjects(): ComboboxObject[] {
    return this.GetContents().map(
      (x) => ({ text: x.description, value: x.value } as ComboboxObject)
    );
  }

  public GetDescriptionFromValue(value: Type): string {
    return this.GetContents().find((x) => x.value === value)?.description ?? "";
  }

  // The member's own name, such as accountsRecievableByInvoice, for a usage name that still
  // reads right when a value is a bare number and survives the description being reworded.
  public GetNameFromValue(value: Type): string {
    const members = this.constructor as unknown as Record<string, unknown>;
    const name = Object.keys(members).find((key) => {
      const member = members[key];
      return member instanceof BaseEnumerationMember && member.value === value;
    });

    return name ?? String(value);
  }
}
